// @flow
import { ACTIONS } from '../constants';
import setNotificationSetting from '../api/setNotificationSetting';

const setNotificationSettingPush = (key: string, enabled: boolean) => (
    dispatch: Function
) => {
    setNotificationSetting(key, enabled);

    dispatch({
        type: ACTIONS.NOTIFICATION_SETTINGS_SET_PUSH,
        key,
        enabled
    });
};

export default setNotificationSettingPush;
